export const HOTMART_LINK_DEFAULT_LABEL = 'Hotmart'
export const HOTMART_URL = 'https://www.hotmart.com/'
